/**
 * Shared symbol-rendering tokens for the ComponentKind nodeTypes.
 *
 * One palette across every symbol so the canvas reads as a coherent
 * schematic — strokes are phosphor cyan on the blueprint backdrop;
 * the body fill is the sunken surface so refdes labels punch through
 * the symbol without overlapping the stroke.
 *
 * Pulled into a tiny module so theme-token changes don't require
 * editing five symbol files.
 */
import type { Theme } from "@mui/material/styles";

export interface SymbolColors {
  stroke: string;
  fill: string;
  text: string;
  faint: string;
  glow: string;
}

export function symbolColors(t: Theme): SymbolColors {
  return {
    stroke: t.palette.accent.main,
    fill: t.palette.surface.sunken,
    text: t.palette.text.primary,
    faint: t.palette.text.secondary,
    glow: t.palette.accent.glow,
  };
}

/** Standard stroke width used by every symbol — 1.5px so they read at
 *  zoomed-in and zoomed-out scales without breaking up. */
export const SYMBOL_STROKE_WIDTH = 1.5;

/** Refdes / value label rendering — small mono so multi-row IC pin
 *  labels fit. */
export const LABEL_STYLE = {
  fontFamily: "JetBrains Mono, ui-monospace, monospace",
  fontSize: 10,
  fontWeight: 500,
} as const;
